import React, { useEffect, useMemo, useState } from 'react';
import styles from './Testimonial.module.scss';
import InfoButton from '../../Atoms/InfoButton/InfoButton';
import moreInfo from '../../../assets/icons/programs/major/moreInfo.svg';
import editSvg from '../../../assets/icons/formActions/edit.svg';
import deleteSvg from '../../../assets/icons/formActions/delete.svg';
import { useNavigate } from 'react-router-dom';
import DeletePopup from '../Custom/DeletePopup';
import quotationsIcon from '../../../assets/Imagess/quotations.svg';
import { useDeleteTestimonial } from '../../../Hooks/Testimonials';
import TestimonialInfoModal from './TestimonialInfoModal';
import he from 'he';
import { useToast } from '../Custom/CustomToaster/Toast';
import noImageFound from '../../../assets/Imagess/no-image-found.jpg';
import { sanitizeAndValidateUrl } from '../../../app/helpers/sanitizeAndValidateUrl';

function Testimonial({ testimonial, refetch, view }) {
  const [showInfo, setShowInfo] = useState(false);
  const navigate = useNavigate();
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const customizedToast = useToast();
  const {
    mutate: deleteTestimonial,
    isLoading: isDeleting,
    isSuccess,
  } = useDeleteTestimonial(testimonial?.testimonialId);

  useEffect(() => {
    setIsActive(testimonial?.isActive);
  }, [testimonial]);

  useEffect(() => {
    if (isSuccess) {
      customizedToast.open(
        !testimonial?.isTestimonial ? 'تم الحذف بنجاح' : 'تم الحذف بنجاح'
      );
      refetch();
      setShowDeletePopup(false);
      setShowInfo(false);
    }
  }, [isSuccess]);

  const menuItems = [
    {
      label: 'تعديل',
      icon: editSvg,
      onClick: () => {
        navigate(
          `/home/update-speech/${
            !testimonial?.isTestimonial ? 'speech' : 'testimonial'
          }/${testimonial?.testimonialId}`
        );
      },
    },
    {
      label: 'حذف',
      icon: deleteSvg,
      onClick: () => {
        setShowDeletePopup(true);
      },
    },
  ];

  const decodedHTML = testimonial ? he.decode(testimonial?.testimonial_AR) : '';
  const firstPHTML = useMemo(() => {
    if (!decodedHTML) return '';
    const parser = new DOMParser();
    const doc = parser.parseFromString(decodedHTML, 'text/html');
    const firstP = doc.querySelector('p');
    return firstP ? firstP.outerHTML : '';
  }, [decodedHTML]);

  return (
    <div className={styles['testimonial-card']}>
      <div className={styles['testimonial-card-info']}>
        <div className={styles['row']}>
          <img src={quotationsIcon} className={styles.quotation} />
          {!view && (
            <InfoButton
              icon={moreInfo}
              className={styles['more-info']}
              data={menuItems}
              left
            />
          )}
        </div>
        <div
          className={styles['row']}
          style={{
            paddingTop: '0px',
            paddingBottom: '26px',
            cursor: 'pointer',
          }}
          onClick={() => setShowInfo(true)}
        >
          <div className={styles['description']}>
            <p
              className={styles['text']}
              dangerouslySetInnerHTML={{ __html: firstPHTML }}
            />
          </div>
        </div>
      </div>
      <div className={styles['bottom-card']}>
        <img
          src={sanitizeAndValidateUrl(
            `${testimonial?.url}${testimonial?.testimonialImage}`
          )}
          className={styles['testimonial-rounded-image']}
          onError={({ currentTarget }) => {
            currentTarget.onerror = null;
            currentTarget.src = noImageFound;
          }}
        />
        <div className={styles['name-container']}>
          <p className={styles['name-title']}>الاسم</p>
          <p className={styles['name']}>{testimonial?.fullName_AR}</p>
        </div>
      </div>
      {showInfo && (
        <TestimonialInfoModal
          data={testimonial}
          handleOnClose={() => setShowInfo(false)}
          setShowDeletePopup={setShowDeletePopup}
          view={view}
        />
      )}
      {showDeletePopup && (
        <DeletePopup
          handleOnClose={() => setShowDeletePopup(false)}
          title={!testimonial?.isTestimonial ? 'خطاب' : 'توصية'}
          handleDelete={() => {
            deleteTestimonial();
            refetch();
          }}
          isLoading={isDeleting}
        />
      )}
    </div>
  );
}

export default Testimonial;
